module.exports = __webpack_public_path__ + "img/logo_b_s.a595d6db.png";